/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { DownloadsCardFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { DownloadsCardFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';
import { getDownloadItemDataMock, getDownloadItemFragmentedData } from '../DownloadItem/mockdata';

export const downloadsCardDataMock: DownloadsCardFragmentFragment = {
  downloads: [
    getDownloadItemFragmentedData(getDownloadItemDataMock('ASSEMBLY_INSTRUCTIONS')),
    getDownloadItemFragmentedData(getDownloadItemDataMock('SAFETY_DATASHEET')),
    getDownloadItemFragmentedData(getDownloadItemDataMock('USER_MANUAL')),
  ],
};

export function getDownloadsCardFragmentedData(data?: DownloadsCardFragmentFragment) {
  return makeFragmentData(data || downloadsCardDataMock, DownloadsCardFragmentFragmentDoc);
}
